export default __webpack_public_path__ + "f7af7afa20571639917a7bd7bb47352f.png";